export default __webpack_public_path__ + "static/media/social_telegram.beb5fe23.svg";